import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import {
  fetchSettings,
  updateSettings,
  clearSuccess as clearSettingsSuccess,
} from "../redux/settingsSlice";

import {
  fetchContact,
  updateContact,
  clearSuccess as clearContactSuccess,
} from "../redux/contactSlice";
import { fetchAbout, updateAbout } from "../redux/aboutSlice";



const AdminSettingsPage = () => {
  const dispatch = useDispatch();

  // Settings state
  const {
    data: settings,
    loading: loadingSettings,
    success: successSettings,
  } = useSelector((state) => state.settings);

  // Contact state
  const {
    data: contact,
    loading: loadingContact,
    success: successContact,
  } = useSelector((state) => state.contact);

  // About state
  const {
    data: about,
    loading: loadingAbout,
    success: successAbout,
  } = useSelector((state) => state.about);

  // Genel Ayarlar State
  const [siteTitle, setSiteTitle] = useState("");
  const [siteDescription, setSiteDescription] = useState("");

  // İletişim Bilgileri State
  const [mail, setMail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [spreeCode, setSpreeCode] = useState("");

  // Hakkımızda State
  const [aboutTitle, setAboutTitle] = useState("");
  const [aboutImage, setAboutImage] = useState("");
  const [aboutContent, setAboutContent] = useState("");
  const [aboutImageUploading, setAboutImageUploading] = useState(false);

  // Ortak
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  // Cloudinary upload helper
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "materialblog"); // Kendi preset’in olmalı
    const res = await axios.post(
      "https://api.cloudinary.com/v1_1/da2mjic2e/image/upload",
      formData
    );
    return res.data.secure_url;
  };

  const handleAboutImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAboutImageUploading(true);
    try {
      const url = await uploadToCloudinary(file);
      setAboutImage(url);
    } catch (err) {
      setToast({
        show: true,
        message: "Görsel yüklenirken hata oluştu",
        type: "danger",
      });
    } finally {
      setAboutImageUploading(false);
    }
  };

  // Veri çekme
  useEffect(() => {
    dispatch(fetchSettings());
    dispatch(fetchContact());
    dispatch(fetchAbout());
  }, [dispatch]);

  // Ayarları state’e set et
  useEffect(() => {
    if (settings) {
      setSiteTitle(settings.siteTitle || "");
      setSiteDescription(settings.siteDescription || "");
    }
  }, [settings]);

  // İletişim bilgilerini state’e set et
  useEffect(() => {
    if (contact) {
      setMail(contact.mail || "");
      setPhoneNumber(contact.phoneNumber || "");
      setAddress(contact.address || "");
      setSpreeCode(contact.spreeCode || "");
    }
  }, [contact]);

  // Hakkımızda bilgilerini state’e set et
  useEffect(() => {
    if (about) {
      setAboutTitle(about.title || "");
      setAboutImage(about.image || "");
      setAboutContent(about.content || "");
    }
  }, [about]);

  // Başarı mesajlarını göster ve temizle
  useEffect(() => {
    if (successSettings) {
      setToast({ show: true, message: "Ayarlar kaydedildi", type: "success" });
      dispatch(clearSettingsSuccess());
      setSaving(false);
    }
    if (successContact) {
      setToast({
        show: true,
        message: "İletişim bilgileri kaydedildi",
        type: "success",
      });
      dispatch(clearContactSuccess());
      setSaving(false);
    }
    if (successAbout) {
      setToast({
        show: true,
        message: "Hakkımızda bilgisi kaydedildi",
        type: "success",
      });
      setSaving(false);
    }
  }, [successSettings, successContact, successAbout, dispatch]);

  // Kaydet butonları handlerları
  const handleSaveSettings = () => {
    setSaving(true);
    dispatch(updateSettings({ siteTitle, siteDescription })).catch(() => {
      setToast({ show: true, message: "Ayar kaydetme hatası", type: "danger" });
      setSaving(false);
    });
  };

  const handleSaveContact = () => {
    setSaving(true);
    dispatch(
      updateContact({
        mail,
        phoneNumber,
        address,
        spreeCode,
      })
    )
      .unwrap()
      .catch((err) => {
        setToast({
          show: true,
          message: err || "İletişim bilgileri kaydedilemedi",
          type: "danger",
        });
        setSaving(false);
      });
  };

  const handleSaveAbout = () => {
    setSaving(true);
    dispatch(
      updateAbout({
        title: aboutTitle,
        image: aboutImage,
        content: aboutContent,
      })
    )
      .unwrap()
      .catch((err) => {
        setToast({
          show: true,
          message: err || "Hakkımızda bilgisi kaydedilemedi",
          type: "danger",
        });
        setSaving(false);
      });
  };

  if (loadingSettings || loadingContact || loadingAbout) {
    return (
      <div className="d-flex justify-content-center my-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h5 className="fw-bold mb-4">Ayarlar</h5>

      <div className="row">
        {/* Site Settings Card */}
        <div className="col-lg-4 col-md-12 mb-4">
          <div className="card h-100 p-4 d-flex flex-column">
            <h6 className="mb-3 fw-semibold">Genel Ayarlar</h6>
            <div className="mb-3">
              <label htmlFor="siteTitle" className="form-label">
                Site Başlığı
              </label>
              <input
                type="text"
                className="form-control"
                id="siteTitle"
                value={siteTitle}
                onChange={(e) => setSiteTitle(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="siteDescription" className="form-label">
                Site Açıklaması
              </label>
              <textarea
                className="form-control"
                id="siteDescription"
                rows="3"
                value={siteDescription}
                onChange={(e) => setSiteDescription(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary mt-auto"
              onClick={handleSaveSettings}
              disabled={saving}
            >
              {saving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </div>

        {/* Contact Settings Card */}
        <div className="col-lg-4 col-md-12 mb-4">
          <div className="card h-100 p-4 d-flex flex-column">
            <h6 className="mb-3 fw-semibold">İletişim Bilgileri</h6>
            <div className="mb-3">
              <label htmlFor="mail" className="form-label">
                E-posta
              </label>
              <input
                type="email"
                className="form-control"
                id="mail"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phoneNumber" className="form-label">
                Telefon
              </label>
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="spreeCode" className="form-label">
                FormSpree Kodu
              </label>
              <input
                type="text"
                className="form-control"
                id="spreeCode"
                value={spreeCode}
                onChange={(e) => setSpreeCode(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Adres
              </label>
              <input
                type="text"
                className="form-control"
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary mt-auto"
              onClick={handleSaveContact}
              disabled={saving}
            >
              {saving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </div>

        {/* About Settings Card */}
        <div className="col-lg-4 col-md-12 mb-4">
          <div className="card h-100 p-4 d-flex flex-column">
            <h6 className="mb-3 fw-semibold">Hakkımızda</h6>
            <div className="mb-3">
              <label htmlFor="aboutTitle" className="form-label">
                Başlık
              </label>
              <input
                type="text"
                className="form-control"
                id="aboutTitle"
                value={aboutTitle}
                onChange={(e) => setAboutTitle(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="aboutImage" className="form-label">
                Görsel URL
              </label>
              <input
                type="text"
                className="form-control mb-2"
                id="aboutImage"
                value={aboutImage}
                onChange={(e) => setAboutImage(e.target.value)}
                placeholder="Cloudinary veya başka URL"
              />

              <label className="btn btn-outline-secondary">
                Görsel Yükle
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleAboutImageUpload}
                />
              </label>

              {aboutImageUploading && (
                <div className="d-flex justify-content-center mt-2">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    aria-hidden="true"
                  ></div>
                </div>
              )}

              {aboutImage && !aboutImageUploading && (
                <div className="mt-2">
                  <img
                    src={aboutImage}
                    alt="Hakkımızda Görseli"
                    style={{
                      maxHeight: 150,
                      borderRadius: 8,
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="aboutContent" className="form-label">
                İçerik
              </label>
              <textarea
                className="form-control"
                id="aboutContent"
                rows="5"
                value={aboutContent}
                onChange={(e) => setAboutContent(e.target.value)}
              />
            </div>

            <button
              className="btn btn-primary mt-auto"
              onClick={handleSaveAbout}
              disabled={saving}
            >
              {saving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </div>
      </div>

      {/* Toast */}
      <div
        className={`toast align-items-center text-white bg-${toast.type} border-0 position-fixed bottom-0 start-50 translate-middle-x mb-4 ${
          toast.show ? "show" : "hide"
        }`}
        role="alert"
        style={{ zIndex: 1060 }}
      >
        <div className="d-flex">
          <div className="toast-body">{toast.message}</div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            onClick={() => setToast({ ...toast, show: false })}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsPage;
